"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createScopeFactory = void 0;
const ioc_container_1 = require("./ioc-container");
function createScopeFactory(options) {
    return (context) => {
        const { onBuildIocContainer = (() => { return; }) } = options;
        const { eventEmitter, getState, setReducer, dispatch, getScope, scopeName, iocContainer } = context;
        const model = options.modelFactory(getState);
        const builder = ioc_container_1.createIocContainerBuilder(iocContainer);
        onBuildIocContainer(builder);
        eventEmitter === null || eventEmitter === void 0 ? void 0 : eventEmitter.emit('onScopeInit', { builder });
        // invokeOnInit(plugins, builder);
        const scopeIocContainer = builder.build();
        const { getReducer, ...actions } = options.actionCreatorsFactory({
            dispatch,
            scopeName,
            selectors: model.selectors,
            getScope,
            iocContainer: scopeIocContainer,
            eventEmitter
        });
        setReducer(getReducer());
        return {
            model,
            ...actions
        };
    };
}
exports.createScopeFactory = createScopeFactory;
//# sourceMappingURL=scope-factory.js.map